import * as React from "react";
import { IconProps } from "./IconProps";

export const IconEye = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.61308 10.2248C4.51154 13.6312 7.31024 15.2248 10.0006 15.2248C12.6911 15.2248 15.4898 13.6311 17.3882 10.2247C15.4898 6.81832 12.6911 5.22475 10.0007 5.22477C7.31024 5.22479 4.51154 6.8184 2.61308 10.2248ZM10.0006 3.55811C13.5333 3.55808 16.9495 5.7341 19.0742 9.84188C19.1984 10.082 19.1984 10.3675 19.0742 10.6076C16.9495 14.7154 13.5333 16.8914 10.0007 16.8914C6.46803 16.8915 3.05179 14.7154 0.927132 10.6077C0.802935 10.3675 0.802935 10.0821 0.927132 9.84197C3.05179 5.73419 6.46802 3.55813 10.0006 3.55811ZM10.0007 8.55811C9.08018 8.55811 8.33398 9.3043 8.33398 10.2248C8.33398 11.1452 9.08018 11.8914 10.0007 11.8914C10.9211 11.8914 11.6673 11.1452 11.6673 10.2248C11.6673 9.3043 10.9211 8.55811 10.0007 8.55811ZM6.66732 10.2248C6.66732 8.38382 8.1597 6.89144 10.0007 6.89144C11.8416 6.89144 13.334 8.38382 13.334 10.2248C13.334 12.0657 11.8416 13.5581 10.0007 13.5581C8.1597 13.5581 6.66732 12.0657 6.66732 10.2248Z"
          fill={color}
        />
      </svg>
    );
  },
);
